import { MOVE_DUE_RESULT, MOVE_DUE_ERROR } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case MOVE_DUE_RESULT:
      return { ...state, reload: true };
    case MOVE_DUE_ERROR:
      return { ...state, reload: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/MoveDue.js